import { render } from "./Certificado-V2.vue?vue&type=template&id=3f89a9fa&scoped=true"
import script from "./Certificado-V2.vue?vue&type=script&lang=js"
export * from "./Certificado-V2.vue?vue&type=script&lang=js"

import "./Certificado-V2.vue?vue&type=style&index=0&id=3f89a9fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f89a9fa"]])

export default __exports__